import { FC, useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import Modal from "@albertsons/uds/molecule/Modal";
import { OctagonAlert } from "lucide-react";

const UnauthorizedPage: FC = () => {
  const [ldapId, setLdapId] = useState<string>("");

  const { accounts } = useMsal();

  const isOpen = true;

  const closeHandler = () => {};

  useEffect(() => {
    if (accounts.length > 0) {
      const { username } = accounts[0];
      const userLdapId = username.split("@")[0];
      setLdapId(userLdapId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeHandler}
      minHeight={20}
      minWidth={20}
      width={800}
      maxWidth="calc(100vw - 40px)"
      className="bg-white overflow-hidden !rounded-lg"
    >
      {({ close }) => (
        <div data-testid="unauthorized-modal">
          <div className="flex h-12 p-2 bg-neutral-100">
            <div className="flex text-center items-center justify-center font-bold w-full px-3">
              <p>Access Denied!</p>
              <span
                className="ml-auto flex text-center items-center justify-center cursor-pointer"
                onClick={close}
              >
                <OctagonAlert />
              </span>
            </div>
          </div>
          <div className="relative p-5 text-[18px]">
            <p className="mb-3">You don't have access for IMPACT mView.</p>
            <p className="mb-3">
              For requesting access, send an email to{" "}
              <span className="font-semibold">IMPACT Support</span> at{" "}
              <a
                className="underline text-[#118dff]"
                href={`mailto:IMPACT.Support@albertsons.com?subject=IMPACT mView - Requesting Access&body=Please provide me access for IMPACT mView.%0D%0ALDAP ID: ${ldapId}%0D%0ANote (Optional): `}
              >
                IMPACT.Support@albertsons.com
              </a>{" "}
              with the following information:
            </p>
            <p>- LDAP ID</p>
            <p>- Note (Optional)</p>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default UnauthorizedPage;
